import {Suspense, FC} from 'react';
import {HashRouter, Route, Routes} from 'react-router-dom';
import {Skeleton} from '@baidu/qianfan-antd-kit';
import {SCIndexContainer} from '@/styles/modules';
import {routes, unAuthRoute} from './qualify';
import {AuthGuard} from './auth';
import NoMatch from './noMatch';

export function getBaseName(pathname: string) {
    if ([
        '/face/result',
        '/confirm',
        '/auth/iframe',
    ].includes(pathname)) {
        return '/qualify/h5/#';
    }
    return '/qualify/#';
}

const RouterIndex: FC = () => {
    return (
        <HashRouter>
            <Suspense fallback={(
                <SCIndexContainer>
                    <Skeleton active />
                </SCIndexContainer>
            )}
            >
                <Routes>
                    <Route path="qualify">
                        {routes.map((route, i) => (
                            <Route
                                key={route.path + i.toString()}
                                path={route.path}
                                element={
                                    <AuthGuard key={`auth-guard-${route.path + i.toString()}`} path={route.path}>
                                        <route.component />
                                    </AuthGuard>
                                }
                            />
                        ))}
                        <Route key="qualifyNoMatchRoute" path="*" element={<NoMatch />} />
                    </Route>
                    <Route>
                        {unAuthRoute.map((route, i) => (
                            <Route
                                key={route.path + i.toString()}
                                path={route.path}
                                element={<route.component />}
                            />
                        ))}
                    </Route>
                    <Route key="noMatchRoute" path="*" element={<NoMatch />} />
                </Routes>
            </Suspense>
        </HashRouter>
    );
};

export default RouterIndex;
